'use client';

import { Helmet } from 'react-helmet-async';
import { HeroSection } from '@/components/home/HeroSection';
import { AboutSection } from '@/components/home/AboutSection';
import { ServicesSection } from '@/components/home/ServicesSection';
import { FootprintsSection } from '@/components/home/FootprintsSection';
import { PeopleSection } from '@/components/home/PeopleSection';
import { CareerSection } from '@/components/home/CareerSection';
import { TestimonialSection } from '@/components/home/TestimonialSection';
import { ContactSection } from '@/components/shared/ContactSection';
import { useTranslations } from '@/i18n/intl';
import { useSettings } from '@/components/shared/SettingsProvider';

export default function HomePage() {
  const t = useTranslations('Common');
  const settings = useSettings();
  const isCareerEnabled = settings.enable_career !== 'false';

  return (
    <>
      <Helmet>
        <title>{t('header.strategyTitle')}</title>
        <meta name="description" content={t('header.strategyDesc')} />
        <meta property="og:title" content={t('header.strategyTitle')} />
        <meta property="og:description" content={t('header.strategyDesc')} />
      </Helmet>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <FootprintsSection />
      <PeopleSection />
      {isCareerEnabled && <CareerSection />}
      <TestimonialSection />
      <ContactSection />
    </>
  );
}
